// extracted by mini-css-extract-plugin
export default {"buttonsBox":"ButtonGroup_buttonsBox__y3-0Y","submitBtn":"ButtonGroup_submitBtn__4Zz8+","cancelBtn":"ButtonGroup_cancelBtn__m4XNm"};